<template>
  <mdb-container>
    <mdb-col v-if="showSpinner">
      <Spinner />
    </mdb-col>
    <mdb-row>
      <StationForm @station-created="onStationCreated" />
    </mdb-row>

    <mdb-row>
      <StationList :stations="stations" />
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Spinner from "@/components/Spinner";
import StationForm from "@/components/StationForm";
import StationList from "@/components/StationList";
import { mdbRow, mdbCol, mdbContainer } from "mdbvue";

export default {
  name: "StationsConfig",
  components: {
    mdbRow,
    mdbCol,
    mdbContainer,
    Spinner,
    StationForm,
    StationList,
  },
  data() {
    return {
      stations: [],
      isLoading: true,
    };
  },

  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
  created() {
    this.isLoading = false;
    this.getStationList();
    this.isLoading = false;
  },
  methods: {
    onStationCreated(stationInfo) {
      this.stations.unshift(stationInfo);
    },

    getStationList() {
      api
        .getStationList()
        .then((response) => {
          this.stations.push(...response.data);
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
